import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { LocalTimeSerializer_getInstance1j419gm07xrpf as LocalTimeSerializer_getInstance } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/serializers/LocalTimeSerializers.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  StringSerializer_getInstance1p9zda6r6kb23 as StringSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
  BooleanSerializer_getInstance22aja3hu17sxf as BooleanSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
  SerializerFactory1qv9hivitncuv as SerializerFactory,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  createThis2j2avj17cvnv2 as createThis,
  equals2au1ep9vhcato as equals,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  hashCodeq5arwsb9dgti as hashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { values3tr2ffumvy98e as values } from '../../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/DayOfWeek.mjs';
import { createSimpleEnumSerializer2guioz11kk1m0 as createSimpleEnumSerializer } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Enums.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  DurationSerializer_getInstance24c8qta2pbnpd as DurationSerializer_getInstance,
  InstantSerializer_getInstance1n2pd669tdsta as InstantSerializer_getInstance,
  UuidSerializer_getInstance1ib26ji9vwcd4 as UuidSerializer_getInstance,
} from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/BuiltInSerializers.mjs';
import {
  Duration5ynfiptaqcrg as Duration,
  Duration__hashCode_impl_u4exz62capomnnb6e8m as Duration__hashCode_impl_u4exz6,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/time/Duration.mjs';
import { get_nullable197rfua9r7fsz as get_nullable } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  IndexSetppgakdbfpe00 as IndexSet,
  Index2tzg8vllut89f as Index,
} from '../../../../../service-abstractions-data-shared/com/lightningkite/services/data/Annotations.mjs';
import { Companion_getInstance2o9uk4k3kfl5 as Companion_getInstance } from '../../../../../kotlin-kotlin-stdlib/kotlin/uuid/Uuid.mjs';
import { $serializer_getInstancee9uv99qo59n5 as $serializer_getInstance } from './events/eventModels.mjs';
import { HasId24qpfucecockd as HasId } from '../../../../../service-abstractions-database-shared/com/lightningkite/services/database/HasId.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.TimeInZone', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('time', false);
        tmp0_serialDesc.addElement_5pzumi_k$('zone', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_x25z86_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, LocalTimeSerializer_getInstance(), value.time_1);
        tmp1_output.encodeStringElement_1n5wu2_k$(tmp0_desc, 1, value.zone_1);
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_x25z86_k$(encoder, value instanceof TimeInZone() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, LocalTimeSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, LocalTimeSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeStringElement_3oenpg_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return TimeInZone().new_com_lightningkite_lightningserver_notifications_TimeInZone_rzgtsj_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [LocalTimeSerializer_getInstance(), StringSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance_0() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var TimeInZoneClass;
function TimeInZone() {
  if (TimeInZoneClass === VOID) {
    class $ {
      constructor(time, zone) {
        this.time_1 = time;
        this.zone_1 = zone;
      }
      toString() {
        return 'TimeInZone(time=' + this.time_1.toString() + ', zone=' + this.zone_1 + ')';
      }
      hashCode() {
        var result = this.time_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.zone_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof TimeInZone()))
          return false;
        if (!this.time_1.equals(other.time_1))
          return false;
        if (!(this.zone_1 === other.zone_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_notifications_TimeInZone_rzgtsj_k$(seen0, time, zone, serializationConstructorMarker) {
        if (!(3 === (3 & seen0))) {
          throwMissingFieldException(seen0, 3, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        $this.time_1 = time;
        $this.zone_1 = zone;
        return $this;
      }
    }
    initMetadataForClass($, 'TimeInZone', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    TimeInZoneClass = $;
  }
  return TimeInZoneClass;
}
function Frequency$Companion$$childSerializers$_anonymous__7nk5xq() {
  return createSimpleEnumSerializer('kotlinx.datetime.DayOfWeek', values());
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, Frequency$Companion$$childSerializers$_anonymous__7nk5xq), null, null];
      }
      immediately_trp1j6_k$() {
        return new (Frequency())(null, null, null, null);
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.Frequency', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('onlyAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('onlyOn', false);
        tmp0_serialDesc.addElement_5pzumi_k$('batchMinutes', false);
        tmp0_serialDesc.addElement_5pzumi_k$('delay', false);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_tyw87e_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 0, $serializer_getInstance_0(), value.onlyAt_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.onlyOn_1);
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 2, IntSerializer_getInstance(), value.batchMinutes_1);
        var tmp = DurationSerializer_getInstance();
        var tmp_0 = value.delay_1;
        tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (Duration())(tmp_0));
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_tyw87e_k$(encoder, value instanceof Frequency() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp9_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, tmp9_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          var tmp = DurationSerializer_getInstance();
          var tmp_0 = tmp7_local3;
          var tmp_1 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp, tmp_0 == null ? null : new (Duration())(tmp_0));
          tmp7_local3 = tmp_1 == null ? null : tmp_1.rawValue_1;
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 0, $serializer_getInstance_0(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 1, tmp9_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 2, IntSerializer_getInstance(), tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                var tmp_2 = DurationSerializer_getInstance();
                var tmp_3 = tmp7_local3;
                var tmp_4 = tmp8_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 3, tmp_2, tmp_3 == null ? null : new (Duration())(tmp_3));
                tmp7_local3 = tmp_4 == null ? null : tmp_4.rawValue_1;
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Frequency().new_com_lightningkite_lightningserver_notifications_Frequency_yg0ld6_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_1().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [get_nullable($serializer_getInstance_0()), get_nullable(tmp0_cached[1].get_value_j01efc_k$()), get_nullable(IntSerializer_getInstance()), get_nullable(DurationSerializer_getInstance())];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_1() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var FrequencyClass;
function Frequency() {
  if (FrequencyClass === VOID) {
    class $ {
      constructor(onlyAt, onlyOn, batchMinutes, delay) {
        Companion_getInstance_1();
        this.onlyAt_1 = onlyAt;
        this.onlyOn_1 = onlyOn;
        this.batchMinutes_1 = batchMinutes;
        this.delay_1 = delay;
      }
      toString() {
        var tmp = toString(this.onlyAt_1);
        var tmp_0 = toString(this.onlyOn_1);
        var tmp_1 = this.delay_1;
        return 'Frequency(onlyAt=' + tmp + ', onlyOn=' + tmp_0 + ', batchMinutes=' + this.batchMinutes_1 + ', delay=' + toString(tmp_1 == null ? null : new (Duration())(tmp_1)) + ')';
      }
      hashCode() {
        var result = this.onlyAt_1 == null ? 0 : this.onlyAt_1.hashCode();
        result = imul(result, 31) + (this.onlyOn_1 == null ? 0 : this.onlyOn_1.hashCode()) | 0;
        result = imul(result, 31) + (this.batchMinutes_1 == null ? 0 : this.batchMinutes_1) | 0;
        var tmp = imul(result, 31);
        var tmp_0;
        var tmp_1 = this.delay_1;
        if ((tmp_1 == null ? null : new (Duration())(tmp_1)) == null) {
          tmp_0 = 0;
        } else {
          tmp_0 = Duration__hashCode_impl_u4exz6(this.delay_1);
        }
        result = tmp + tmp_0 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Frequency()))
          return false;
        if (!equals(this.onlyAt_1, other.onlyAt_1))
          return false;
        if (!equals(this.onlyOn_1, other.onlyOn_1))
          return false;
        if (!(this.batchMinutes_1 == other.batchMinutes_1))
          return false;
        var tmp = this.delay_1;
        var tmp_0 = tmp == null ? null : new (Duration())(tmp);
        var tmp_1 = other.delay_1;
        if (!equals(tmp_0, tmp_1 == null ? null : new (Duration())(tmp_1)))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_notifications_Frequency_yg0ld6_k$(seen0, onlyAt, onlyOn, batchMinutes, delay, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(15 === (15 & seen0))) {
          throwMissingFieldException(seen0, 15, $serializer_getInstance_1().descriptor_1);
        }
        var $this = createThis(this);
        $this.onlyAt_1 = onlyAt;
        $this.onlyOn_1 = onlyOn;
        $this.batchMinutes_1 = batchMinutes;
        $this.delay_1 = delay;
        return $this;
      }
    }
    initMetadataForClass($, 'Frequency', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    FrequencyClass = $;
  }
  return FrequencyClass;
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_2();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.SendInfo', this, 2);
        tmp0_serialDesc.addElement_5pzumi_k$('sendAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('sent', true);
        tmp0_serialDesc.pushClassAnnotation_xtmllk_k$(new (IndexSet())(['sent', 'sendAt']));
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_mv8fky_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, InstantSerializer_getInstance(), value.sendAt_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !(value.sent_1 === false)) {
          tmp1_output.encodeBooleanElement_ydht7q_k$(tmp0_desc, 1, value.sent_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_mv8fky_k$(encoder, value instanceof SendInfo() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = false;
        var tmp6_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp6_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, InstantSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp6_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp6_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp6_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, InstantSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp6_input.decodeBooleanElement_vuyhtj_k$(tmp0_desc, 1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp6_input.endStructure_1xqz0n_k$(tmp0_desc);
        return SendInfo().new_com_lightningkite_lightningserver_notifications_SendInfo_7k789u_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [InstantSerializer_getInstance(), BooleanSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_2() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var SendInfoClass;
function SendInfo() {
  if (SendInfoClass === VOID) {
    class $ {
      constructor(sendAt, sent) {
        sent = sent === VOID ? false : sent;
        this.sendAt_1 = sendAt;
        this.sent_1 = sent;
      }
      toString() {
        return 'SendInfo(sendAt=' + this.sendAt_1.toString() + ', sent=' + this.sent_1 + ')';
      }
      hashCode() {
        var result = this.sendAt_1.hashCode();
        result = imul(result, 31) + getBooleanHashCode(this.sent_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SendInfo()))
          return false;
        if (!this.sendAt_1.equals(other.sendAt_1))
          return false;
        if (!(this.sent_1 === other.sent_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_notifications_SendInfo_7k789u_k$(seen0, sendAt, sent, serializationConstructorMarker) {
        if (!(1 === (1 & seen0))) {
          throwMissingFieldException(seen0, 1, $serializer_getInstance_2().descriptor_1);
        }
        var $this = createThis(this);
        $this.sendAt_1 = sendAt;
        if (0 === (seen0 & 2))
          $this.sent_1 = false;
        else
          $this.sent_1 = sent;
        return $this;
      }
    }
    initMetadataForClass($, 'SendInfo', VOID, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_2});
    SendInfoClass = $;
  }
  return SendInfoClass;
}
var CompanionClass_2;
function Companion_2() {
  if (CompanionClass_2 === VOID) {
    class $ {
      constructor() {
        Companion_instance_2 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.Notification', null, 10);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('event', false);
        tmp0_serialDesc.addElement_5pzumi_k$('user', false);
        tmp0_serialDesc.addElement_5pzumi_k$('content', false);
        tmp0_serialDesc.addElement_5pzumi_k$('createdAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('read', true);
        tmp0_serialDesc.addElement_5pzumi_k$('email', true);
        tmp0_serialDesc.addElement_5pzumi_k$('push', true);
        tmp0_serialDesc.addElement_5pzumi_k$('sms', true);
        tmp0_serialDesc.addElement_5pzumi_k$('inApp', true);
        this.$cachedDescriptor_1 = tmp0_serialDesc;
      }
      serializer_o2vhsn_k$(typeSerial0, typeSerial1) {
        return $serializer_2().new_com_lightningkite_lightningserver_notifications_Notification_$serializer_vkjsf9_k$(typeSerial0, typeSerial1);
      }
      serializer_nv39qc_k$(typeParamsSerializers) {
        return this.serializer_o2vhsn_k$(typeParamsSerializers[0], typeParamsSerializers[1]);
      }
    }
    initMetadataForCompanion($, VOID, [SerializerFactory()]);
    CompanionClass_2 = $;
  }
  return CompanionClass_2;
}
var Companion_instance_2;
function Companion_getInstance_3() {
  if (Companion_instance_2 === VOID)
    new (Companion_2())();
  return Companion_instance_2;
}
var $serializerClass_2;
function $serializer_2() {
  if ($serializerClass_2 === VOID) {
    class $ {
      constructor() {
        return new.target.new_com_lightningkite_lightningserver_notifications_Notification_$serializer_fnvli4_k$();
      }
      static new_com_lightningkite_lightningserver_notifications_Notification_$serializer_fnvli4_k$() {
        var $this = createThis(this);
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('com.lightningkite.lightningserver.notifications.Notification', $this, 10);
        tmp0_serialDesc.addElement_5pzumi_k$('_id', true);
        tmp0_serialDesc.addElement_5pzumi_k$('event', false);
        tmp0_serialDesc.addElement_5pzumi_k$('user', false);
        tmp0_serialDesc.pushAnnotation_fm15ho_k$(new (Index())());
        tmp0_serialDesc.addElement_5pzumi_k$('content', false);
        tmp0_serialDesc.addElement_5pzumi_k$('createdAt', false);
        tmp0_serialDesc.addElement_5pzumi_k$('read', true);
        tmp0_serialDesc.addElement_5pzumi_k$('email', true);
        tmp0_serialDesc.addElement_5pzumi_k$('push', true);
        tmp0_serialDesc.addElement_5pzumi_k$('sms', true);
        tmp0_serialDesc.addElement_5pzumi_k$('inApp', true);
        $this.descriptor_1 = tmp0_serialDesc;
        return $this;
      }
      serialize_41ea2c_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !value._id_1.equals(Companion_getInstance().random_fimq0t_k$())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 0, UuidSerializer_getInstance(), value._id_1);
        }
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, $serializer_getInstance(), value.event_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 2, this.typeSerial0__1, value.user_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 3, this.typeSerial1__1, value.content_1);
        tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 4, InstantSerializer_getInstance(), value.createdAt_1);
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !(value.read_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 5, InstantSerializer_getInstance(), value.read_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 6) ? true : !(value.email_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 6, $serializer_getInstance_2(), value.email_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 7) ? true : !(value.push_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 7, $serializer_getInstance_2(), value.push_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 8) ? true : !(value.sms_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 8, $serializer_getInstance_2(), value.sms_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 9) ? true : !(value.inApp_1 == null)) {
          tmp1_output.encodeNullableSerializableElement_5lquiv_k$(tmp0_desc, 9, $serializer_getInstance_2(), value.inApp_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_41ea2c_k$(encoder, value instanceof Notification() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = null;
        var tmp5_local1 = null;
        var tmp6_local2 = null;
        var tmp7_local3 = null;
        var tmp8_local4 = null;
        var tmp9_local5 = null;
        var tmp10_local6 = null;
        var tmp11_local7 = null;
        var tmp12_local8 = null;
        var tmp13_local9 = null;
        var tmp14_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        if (tmp14_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, this.typeSerial0__1, tmp6_local2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, this.typeSerial1__1, tmp7_local3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, InstantSerializer_getInstance(), tmp9_local5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
          tmp10_local6 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
          tmp3_bitMask0 = tmp3_bitMask0 | 64;
          tmp11_local7 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, $serializer_getInstance_2(), tmp11_local7);
          tmp3_bitMask0 = tmp3_bitMask0 | 128;
          tmp12_local8 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, $serializer_getInstance_2(), tmp12_local8);
          tmp3_bitMask0 = tmp3_bitMask0 | 256;
          tmp13_local9 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, $serializer_getInstance_2(), tmp13_local9);
          tmp3_bitMask0 = tmp3_bitMask0 | 512;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp14_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 0, UuidSerializer_getInstance(), tmp4_local0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, $serializer_getInstance(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 2, this.typeSerial0__1, tmp6_local2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 3, this.typeSerial1__1, tmp7_local3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp14_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 4, InstantSerializer_getInstance(), tmp8_local4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 5, InstantSerializer_getInstance(), tmp9_local5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              case 6:
                tmp10_local6 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 6, $serializer_getInstance_2(), tmp10_local6);
                tmp3_bitMask0 = tmp3_bitMask0 | 64;
                break;
              case 7:
                tmp11_local7 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 7, $serializer_getInstance_2(), tmp11_local7);
                tmp3_bitMask0 = tmp3_bitMask0 | 128;
                break;
              case 8:
                tmp12_local8 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 8, $serializer_getInstance_2(), tmp12_local8);
                tmp3_bitMask0 = tmp3_bitMask0 | 256;
                break;
              case 9:
                tmp13_local9 = tmp14_input.decodeNullableSerializableElement_k2y6ab_k$(tmp0_desc, 9, $serializer_getInstance_2(), tmp13_local9);
                tmp3_bitMask0 = tmp3_bitMask0 | 512;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp14_input.endStructure_1xqz0n_k$(tmp0_desc);
        return Notification().new_com_lightningkite_lightningserver_notifications_Notification_joo8m1_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, tmp10_local6, tmp11_local7, tmp12_local8, tmp13_local9, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [UuidSerializer_getInstance(), $serializer_getInstance(), this.typeSerial0__1, this.typeSerial1__1, InstantSerializer_getInstance(), get_nullable(InstantSerializer_getInstance()), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_2()), get_nullable($serializer_getInstance_2())];
      }
      typeParametersSerializers_fr94fx_k$() {
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [this.typeSerial0__1, this.typeSerial1__1];
      }
      static new_com_lightningkite_lightningserver_notifications_Notification_$serializer_vkjsf9_k$(typeSerial0, typeSerial1) {
        var $this = this.new_com_lightningkite_lightningserver_notifications_Notification_$serializer_fnvli4_k$();
        $this.typeSerial0__1 = typeSerial0;
        $this.typeSerial1__1 = typeSerial1;
        return $this;
      }
    }
    initMetadataForClass($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_2 = $;
  }
  return $serializerClass_2;
}
var NotificationClass;
function Notification() {
  if (NotificationClass === VOID) {
    class $ {
      constructor(_id, event, user, content, createdAt, read, email, push, sms, inApp) {
        Companion_getInstance_3();
        _id = _id === VOID ? Companion_getInstance().random_fimq0t_k$() : _id;
        read = read === VOID ? null : read;
        email = email === VOID ? null : email;
        push = push === VOID ? null : push;
        sms = sms === VOID ? null : sms;
        inApp = inApp === VOID ? null : inApp;
        this._id_1 = _id;
        this.event_1 = event;
        this.user_1 = user;
        this.content_1 = content;
        this.createdAt_1 = createdAt;
        this.read_1 = read;
        this.email_1 = email;
        this.push_1 = push;
        this.sms_1 = sms;
        this.inApp_1 = inApp;
      }
      get__id_18jb1r_k$() {
        return this._id_1;
      }
      toString() {
        return 'Notification(_id=' + this._id_1.toString() + ', event=' + this.event_1.toString() + ', user=' + toString(this.user_1) + ', content=' + toString(this.content_1) + ', createdAt=' + this.createdAt_1.toString() + ', read=' + toString(this.read_1) + ', email=' + toString(this.email_1) + ', push=' + toString(this.push_1) + ', sms=' + toString(this.sms_1) + ', inApp=' + toString(this.inApp_1) + ')';
      }
      hashCode() {
        var result = this._id_1.hashCode();
        result = imul(result, 31) + this.event_1.hashCode() | 0;
        result = imul(result, 31) + (this.user_1 == null ? 0 : hashCode(this.user_1)) | 0;
        result = imul(result, 31) + (this.content_1 == null ? 0 : hashCode(this.content_1)) | 0;
        result = imul(result, 31) + this.createdAt_1.hashCode() | 0;
        result = imul(result, 31) + (this.read_1 == null ? 0 : this.read_1.hashCode()) | 0;
        result = imul(result, 31) + (this.email_1 == null ? 0 : this.email_1.hashCode()) | 0;
        result = imul(result, 31) + (this.push_1 == null ? 0 : this.push_1.hashCode()) | 0;
        result = imul(result, 31) + (this.sms_1 == null ? 0 : this.sms_1.hashCode()) | 0;
        result = imul(result, 31) + (this.inApp_1 == null ? 0 : this.inApp_1.hashCode()) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Notification()))
          return false;
        if (!this._id_1.equals(other._id_1))
          return false;
        if (!this.event_1.equals(other.event_1))
          return false;
        if (!equals(this.user_1, other.user_1))
          return false;
        if (!equals(this.content_1, other.content_1))
          return false;
        if (!this.createdAt_1.equals(other.createdAt_1))
          return false;
        if (!equals(this.read_1, other.read_1))
          return false;
        if (!equals(this.email_1, other.email_1))
          return false;
        if (!equals(this.push_1, other.push_1))
          return false;
        if (!equals(this.sms_1, other.sms_1))
          return false;
        if (!equals(this.inApp_1, other.inApp_1))
          return false;
        return true;
      }
      static new_com_lightningkite_lightningserver_notifications_Notification_joo8m1_k$(seen0, _id, event, user, content, createdAt, read, email, push, sms, inApp, serializationConstructorMarker) {
        Companion_getInstance_3();
        if (!(30 === (30 & seen0))) {
          throwMissingFieldException(seen0, 30, Companion_getInstance_3().$cachedDescriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this._id_1 = Companion_getInstance().random_fimq0t_k$();
        else
          $this._id_1 = _id;
        $this.event_1 = event;
        $this.user_1 = user;
        $this.content_1 = content;
        $this.createdAt_1 = createdAt;
        if (0 === (seen0 & 32))
          $this.read_1 = null;
        else
          $this.read_1 = read;
        if (0 === (seen0 & 64))
          $this.email_1 = null;
        else
          $this.email_1 = email;
        if (0 === (seen0 & 128))
          $this.push_1 = null;
        else
          $this.push_1 = push;
        if (0 === (seen0 & 256))
          $this.sms_1 = null;
        else
          $this.sms_1 = sms;
        if (0 === (seen0 & 512))
          $this.inApp_1 = null;
        else
          $this.inApp_1 = inApp;
        return $this;
      }
    }
    initMetadataForClass($, 'Notification', VOID, VOID, [HasId()], VOID, VOID, {0: Companion_getInstance_3});
    NotificationClass = $;
  }
  return NotificationClass;
}
//region block: init
Companion_instance = new (Companion())();
Companion_instance_1 = new (Companion_1())();
//endregion
//region block: exports
export {
  Notification as Notification1y91jemwm75tr,
  $serializer_getInstance_1 as $serializer_getInstance16n3ee7c06gio,
  Companion_getInstance_1 as Companion_getInstance2ckxqlwfswrwh,
  Companion_getInstance_3 as Companion_getInstanceddq4orui8c5e,
  Companion_instance_1 as Companion_instance1a446aeu2q07d,
  Companion_instance as Companion_instancecl4qgzq2gv8j,
};
//endregion

//# sourceMappingURL=notificationModels.mjs.map
